import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Input, InputGroup, FormGroup, Form, Row, Col, Table } from 'reactstrap';
import { Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IFileEntry } from 'app/shared/model/file-entry.model';
import { searchEntities, getEntities } from './file-entry.reducer';

export const FileEntry = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [search, setSearch] = useState('');

  const fileEntryList = useAppSelector(state => state.fileEntry.entities);
  const loading = useAppSelector(state => state.fileEntry.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const startSearching = e => {
    if (search) {
      dispatch(searchEntities({ query: search }));
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="file-entry-heading" data-cy="FileEntryHeading">
        <Translate contentKey="xtdtApp.fileEntry.home.title">File Entries</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="xtdtApp.fileEntry.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/file-entry/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="xtdtApp.fileEntry.home.createLabel">Create new File Entry</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('xtdtApp.fileEntry.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {fileEntryList && fileEntryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="xtdtApp.fileEntry.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.fileEntry.ten">Ten</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.fileEntry.tenMoRong">Ten Mo Rong</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.fileEntry.duongDan">Duong Dan</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.fileEntry.tenHienThi">Ten Hien Thi</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {fileEntryList.map((fileEntry, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/file-entry/${fileEntry.id}`} color="link" size="sm">
                      {fileEntry.id}
                    </Button>
                  </td>
                  <td>{fileEntry.ten}</td>
                  <td>{fileEntry.tenMoRong}</td>
                  <td>{fileEntry.duongDan}</td>
                  <td>{fileEntry.tenHienThi}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/file-entry/${fileEntry.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`/file-entry/${fileEntry.id}/edit`} color="primary" size="sm" data-cy="entityEditButton">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`/file-entry/${fileEntry.id}/delete`} color="danger" size="sm" data-cy="entityDeleteButton">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="xtdtApp.fileEntry.home.notFound">No File Entries found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default FileEntry;
